import React, { useState } from "react";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { Store } from "@reduxjs/toolkit";
import { useSelector, useStore } from "react-redux";
import { toast } from "react-toastify";
import Lottie from "react-lottie";
import { defaultloadImage } from "../../assets/lottie-animations/animationOptions";
import { api } from "../../config/baseApi";
import ProductImage from "../ProductImage";
import AddToBasketModal from "../AddToBasketModal/AddToBasketModal";

function ProductItem({ product, type }) {
  const { _id, name, description, price, weight, sold, quantity } = product;

  const navigate = useNavigate();
  const store = useStore();
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [addedProduct, setAddedProduct] = useState(null);
  const productsInBasket = useSelector(
    (state: any) => state?.entities?.basketSlice?.product,
  );

  const isProductInBasket = productsInBasket?.some((item) => item._id === _id);



  const addProdToBasket = (product: any) => {
    
    if (typeof product == "object") {
      const objCopy = { ...product };

      objCopy.quantityInBasket = 1;
      objCopy.type = type;
      try {
        store.dispatch({
          type: "basketSlice/add",
          payload: { product: objCopy },
        });
        setAddedProduct(objCopy);
        setShowModal(true);
      } catch (error) {
      }
    }
  };

  const hasSale = sold > 0;
  const finalPrice = hasSale ? price - (price * sold) / 100 : price;

  const inStock = quantity > 0;

  return (
    <>
      <div
        className="product-item"
        onClick={() =>
          type === "package"
            ? navigate(`/package-details/${_id}`)
            : navigate(`/product-details/${_id}`)
        }
      >
        {/* ✅ DISCOUNT BADGE */}
        {hasSale && <span className="badge-sale">-{sold}%</span>}

        {/* ✅ IMAGE */}

        <>
          {type == "package" ? (
            <div className="product-image">
              {!isImageLoaded && (
                <div className="image-loader">
                  <Lottie options={defaultloadImage} height={90} width={90} />
                </div>
              )}

              <img
                src={`${api}/${type}/photo/${_id}`}
                alt={name}
                onLoad={() => setIsImageLoaded(true)}
                className={isImageLoaded ? "visible" : "hidden"}
              />
            </div>
          ) : (
            <ProductImage productId={product?._id} />
          )}
        </>

        {/* ✅ INFO */}
        <div className="product-info">
          <h3 className="product-name">{name}</h3>

          <p className="product-description">{description}</p>

          {/* ✅ META */}
          {type !== "package" && (
            <div className="product-meta">
              <span>
                <b>Stockage :</b> {weight} go
              </span>

              {/* ✅ STOCK TAG */}
              <span className={`stock-tag ${inStock ? "in" : "out"}`}>
                {inStock ? "In Stock" : "Out of Stock"}
              </span>
            </div>
          )}

          {/* ✅ FOOTER */}
          <div className="product-footer">
            <div className="price-block">
              <span className={`price ${hasSale ? "old" : ""}`}>
                <b>Price :</b> {price} DT
              </span>

              {hasSale && (
                <span className="price new">
                  <b>Sale :</b> {finalPrice.toFixed(3)} DT
                </span>
              )}
            </div>

            {isProductInBasket ? (
              <div className="added-badge">
                <span>Ajouté</span>
                <i className="bx bx-check" />
              </div>
            ) : (
              <button
                className="btn-add-to-cart"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  addProdToBasket(product);
                }}
                style={{ opacity: inStock ? 1 : 0.4 }}
              >
                <i className="bx bx-basket" />
              </button>
            )}
          </div>
        </div>
      </div>
      {showModal && (
        <AddToBasketModal
          product={addedProduct}
          quantityInBasket={
            productsInBasket?.find((p) => p._id === addedProduct?._id)
              ?.quantityInBasket || 1
          }
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
}

export default ProductItem;
